export const ru = {
    add_service_error_message: 'Не удалось добавить услугу',
    choose_tariff: 'Выбрать тариф',
};
